export default __webpack_public_path__ + "static/media/inlab-card-en.b2873b77.svg";